var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "100px",
    viewBox: "0 0 250 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kangaroo",
    transform: "translate(160.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,4.20968068 L72,8.60484034 L68,13 L68,1.10157027 C68,0.345749318 68.6797333,-0.188262581 69.3286667,0.0627010355 C70.8848,0.664691404 72,2.29397709 72,4.20968068 Z",
    id: "Path",
    fill: "#FF5A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,1.10152312 L63,13 L59,8.60482292 L59,4.20964585 C59,2.29378816 60.1152,0.664496017 61.6713333,0.0626497695 C62.3202667,-0.188168336 63,0.345699173 63,1.10152312 Z",
    id: "Path",
    fill: "#FF7A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,53 L43,53 L43,67.7777778 C43,70.1098519 44.7906667,72 47,72 L51,72 L51,53 Z",
    id: "Path",
    fill: "#FF3A2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,33 L67.6666667,47 C70.1915556,46.1048112 72,43.690119 72,40.8524573 L72,33 L59,33 Z",
    id: "Path",
    fill: "#FF5A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,13 L67.6,41 C70.2854667,39.4593099 72,36.5880238 72,33.4191044 L72,13 L61,13 Z",
    id: "Path",
    fill: "#FF7A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2591099,12 L59.2591099,20.7445252 C59.2591099,23.1935953 57.3026073,25.1785688 54.8886648,25.1785688 L48.3525186,25.1785688 C40.3997654,25.1785688 33.4493009,30.6235743 31.4388962,38.4304471 L30,44.0112822 L54.5973018,54 L54.5973018,48.3170341 C54.5973018,46.4133514 55.7948038,44.7225028 57.5721181,44.1150388 L63.6295549,42.0428624 L63.6295549,47.0326395 C63.6295549,48.2224412 62.6782547,49.1875847 61.5055186,49.1875847 C60.3298689,49.1875847 59.3173825,50.1054317 59.2620235,51.2967114 C59.2022941,52.5707599 60.203126,53.6216283 61.4443324,53.6216283 C65.0645177,53.6216283 68,50.643429 68,46.9705629 L68,12 L59.2591099,12 Z",
    id: "Path",
    fill: "#FF9A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0862208,68 L64,68 L68.0862208,72 L70.9758599,72 C71.6785536,72 72.1750295,71.3202667 71.9417063,70.6713333 C71.3821664,69.1152 69.8674044,68 68.0862208,68 Z",
    id: "Path",
    fill: "#FF5A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6315326,67.7548385 L54.6033667,67.7548385 L54.6033667,54.7359091 C54.6033667,47.702008 48.7359326,42 41.4979646,42 L34.2438333,42 C32.2563262,42 30.5194236,43.3037326 30.0171955,45.1723735 L25.6526597,61.4107991 C24.6464561,65.1480809 21.1735245,67.754697 17.1982192,67.754697 L2.18423369,67.754697 C0.97795423,67.754697 0,68.7050788 0,69.8773485 C0,71.0496182 0.97795423,72 2.18423369,72 L19.233925,72 C24.2139778,72 28.7630085,69.2575342 30.9749092,64.9216647 L34.945846,57.1414393 L48.0506657,57.1414393 L48.0506657,67.754697 C48.0506657,70.0993778 50.0064285,72 52.419133,72 L68,72 C68,69.6553191 66.0443828,67.7548385 63.6315326,67.7548385 Z",
    id: "Path",
    fill: "#FF7A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0000667,9 L64,16 L68.0000667,23 C68.3684728,22.6950117 68.6770113,22.3058501 68.8944816,21.8482273 L71.1554526,17.0903261 C71.7109285,15.9215785 72,14.6327435 72,13.3259515 L72,9 L68.0000667,9 Z",
    id: "Path",
    fill: "#FF3A2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,9 L60,13.4051009 C60,14.7358025 60.2892048,16.0480757 60.8445474,17.2383501 L63.1055184,22.083304 C63.6536609,23.2580071 64.7742129,24 65.9999667,24 C66.7394457,24 67.439724,23.7284312 68,23.2562928 L68,9 L60,9 Z",
    id: "Path",
    fill: "#FF5A35"
  })), /*#__PURE__*/React.createElement("text", {
    id: "dash",
    fontFamily: "Whitney-Bold, Whitney",
    fontSize: 72,
    fontWeight: "bold",
    fill: "#17345B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35,
    y: 72
  }, "dash")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.317ba7b12d47f06f38b621fb5aa1d6b2.svg";
export { ForwardRef as ReactComponent };